import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Usuario } from 'app/auth/dto/usuario.dto';
import { StorageService } from 'app/service/storage.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AutocompleteService {
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
  ) { }


  getListaAutocompleteByUrl(url): Observable<any[]> {
    // TODO ver cómo sacarlo de algún servicio para solamente ponerle el hash
    return this.http.get<any[]>(environment.url_backend + url);
  }

}
